import { Box } from '@factorialco/deprecated-design-system'
import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { Group } from 'modules/expenses/hooks/useGroup'
import { getStatusLabel } from 'modules/expenses/lib/expensables/statusLabel'
import statusVariant from 'modules/expenses/lib/statusVariant'
import { ExpenseGroupActions } from 'modules/expenses/pages/my_expenses/Groups/DetailPage/usePageActions'

export const GroupHeader = ({ group, actions }: { group: Group; actions: ExpenseGroupActions }) => {
  const {
    access: { locale },
  } = useCurrentSession()

  const moneyAmount = (amount: number): string => {
    if (!group?.currency) return ''

    return MoneyWithCurrency({
      amount,
      currency: group.currency,
      locale,
    })
  }

  return (
    <Box style={{ flexGrow: '0' }}>
      <ResourceHeader
        title={group.name}
        description={group.description ?? ''}
        status={{
          label: getStatusLabel(group.status),
          text: getStatusLabel(group.status),
          variant: statusVariant(group.status),
        }}
        metadata={[
          {
            label: i18n.t('expenses_v2.group_detail.amount'),
            value: {
              type: 'text' as const,
              content: moneyAmount(Number(group.amount)),
            },
          },
          ...(group.owner?.legalEntity?.legalName
            ? [
                {
                  label: i18n.t('expenses_v2.group_detail.legal_entity'),
                  value: {
                    type: 'text' as const,
                    content: group.owner.legalEntity.legalName ?? '',
                  },
                },
              ]
            : []),
        ]}
        primaryAction={actions.primary}
        secondaryActions={actions.secondary}
      />
    </Box>
  )
}
